import React, { CSSProperties } from 'react';

type Props = {
  imageUrl: string;
  size?: number;
  style?: CSSProperties;
  alt?: string;
};

export const AvatarSquare = ({ imageUrl, size = 180, alt='User Avatar', style }: Props): JSX.Element => {
  const classes = 'rounded-2xl';

  return (
    <img src={imageUrl} style={style} className={classes} width={size} height={size} alt={alt} />
  );
};
